import { type PayloadAction, type Slice, createSlice } from '@reduxjs/toolkit';

import { REDUX_SLICE } from '../constants';
import { AppSliceState } from '../types/app.type';

const initialState: AppSliceState = {
  count: 0,
};

export const appSlice: Slice<AppSliceState> = createSlice({
  name: REDUX_SLICE.APP,
  initialState,
  reducers: {
    setCount: (state, action: PayloadAction<number>) => {
      state.count += action.payload;
    },
  },
});
